export interface NavItem {
  to: string;
  label: string;
  /** Only match the exact path (used for the home route). */
  end?: boolean;
}

/**
 * Single source of truth for the primary navigation, consumed by the desktop
 * navigation, the mobile menu, the footer and the sitemap generator.
 */
export const NAV_ITEMS: readonly NavItem[] = [
  { to: '/', label: 'Home', end: true },
  { to: '/about', label: 'About' },
  { to: '/experience', label: 'Experience' },
  { to: '/case-studies', label: 'Case studies' },
  { to: '/contact', label: 'Contact' },
];

export const SECONDARY_NAV_ITEMS: readonly NavItem[] = [
  { to: '/cv', label: 'CV' },
  { to: '/privacy', label: 'Privacy' },
];
